export const SocialPublishingConstants = {
  startDateDay: 0,
  endDateDay: 6
};
